"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElasticsearchProduct = __importStar(require("./ElasticsearchProduct"));
var Indices;
(function (Indices) {
    Indices["PRODUCTS"] = "products";
    Indices["CONTENT"] = "contentful";
})(Indices = exports.Indices || (exports.Indices = {}));
//# sourceMappingURL=index.js.map